import { Component } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout >
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar
        #menuSidebar
        class="menu-sidebar"
        tag="menu-sidebar"
        responsive
        [compactedBreakpoints]="[]"
        [collapsedBreakpoints]="['xs', 'is', 'sm']"
      >
        <ng-content select=".menu-search"></ng-content>
        <ng-content select="nb-menu"></ng-content>
        <ng-content select=".menu-search-empty"></ng-content>
        <ng-content select=".menu-skeleton"></ng-content>
        <ng-content select=".sidebar-shortcuts"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>

    <button
      type="button"
      class="menu-sidebar-backdrop"
      [class.menu-sidebar-backdrop--visible]="menuSidebar.expanded"
      aria-label="بستن منو"
      (click)="closeMenuSidebar()"
    ></button>
  `,
})
// <nb-layout-footer fixed>
//   <ngx-footer></ngx-footer>
// </nb-layout-footer>
export class OneColumnLayoutComponent {
  constructor(private sidebarService: NbSidebarService) {}

  closeMenuSidebar(): void {
    this.sidebarService.collapse('menu-sidebar');
  }
}
